import en from './en.json';
import tr from './tr.json';
export default { tr, en };
